import React from 'react'
import { Typography, Box, Link } from '@mui/material'
import { PROJECT_INFO } from '../../config/config'

const AuthPrompt = () => {
  return (
    <Box
      sx={{
        maxWidth: 500,
        margin: '0 auto',
        padding: 3,
        textAlign: 'center',
        border: '1px solid #e0e0e0',
        borderRadius: 2,
        backgroundColor: '#f9f9f9',
      }}
    >
      <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
        Для оформления заказа
      </Typography>

      <Typography variant="body1" paragraph>
        <Link href="/login/">Авторизуйтесь</Link> или свяжитесь с нами для
        регистрации:
      </Typography>

      <Box sx={{ marginY: 2 }}>
        <Typography variant="body1">
          <Link sx={{ color: '#007e0c', textDecoration: 'none' }}>
            {PROJECT_INFO?.phone}
          </Link>
        </Typography>
        <Typography variant="body1">
          <Link sx={{ color: '#007e0c', textDecoration: 'none' }}>
            {PROJECT_INFO?.phone_2}
          </Link>
        </Typography>
      </Box>

      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ fontStyle: 'italic' }}
      >
        Регистрируем только цветочные магазины и профессиональных участников
        флористической деятельности.
      </Typography>

      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        Частные лица могут приобрести цветы кратно пачки на нашем складе.
      </Typography>
    </Box>
  )
}

export default AuthPrompt
